import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

import SideBarLinkItem from '@/layout/components/sidebar/SideBarLinkItem.vue';

import { SidebarLink } from '@/router/sidebarLinksCreator';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarLink',
  props: {
    sidebarLink: {}
  },
  setup(__props: any) {

const vueProps = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!

  return (vueProps.sidebarLink.childLinks?.length === 0)
    ? (_openBlock(), _createBlock(SideBarLinkItem, {
        key: 0,
        "sidebar-link": vueProps.sidebarLink,
        "nest-level": 1
      }, null, 8, ["sidebar-link"]))
    : (_openBlock(), _createBlock(_component_v_list_group, { key: 1 }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_list_item, _mergeProps(props, {
            "prepend-icon": vueProps.sidebarLink.icon,
            title: vueProps.sidebarLink.name
          }), null, 16, ["prepend-icon", "title"])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vueProps.sidebarLink.childLinks, (childLink) => {
            return (_openBlock(), _createBlock(SideBarLinkItem, {
              key: childLink.name,
              "sidebar-link": childLink,
              "nest-level": 1
            }, null, 8, ["sidebar-link"]))
          }), 128))
        ]),
        _: 1
      }))
}
}

})